// components/CustomToast.js
import React from 'react';

const CustomToast = ({ message, type }) => {
  const bgColor = {
    success: '#d4edda',
    error: '#f8d7da',
    info: '#d1ecf1',
    warning: '#fff3cd',
    loaction:'#31c8eb'
  };

  const textColor = {
    success: '#155724',
    error: '#721c24',
    info: '#0c5460',
    warning: '#856404'
  };

  return (
    <div
      style={{
        backgroundColor: bgColor[type] || '#f8f9fa',
        color: textColor[type] || '#212529',
        padding: '10px 15px',
        borderRadius: '5px',
        fontWeight: 500
      }}
    >
      {message}
    </div>
  );
};

export default CustomToast;
